(() => {
  if (window.mhLttReviewsInit) { window.mhLttReviewsInit(); return; }
  const instances = new Map();

  function mount(root) {
    const source = root.querySelector('[data-reviews-source]');
    const layout = root.querySelector('[data-reviews-layout]');
    const loading = root.querySelector('[data-reviews-loading]');
    if (!source || !layout) return;
    const controller = new AbortController();
    const on = (target, type, fn) => target?.addEventListener(type, fn, { signal: controller.signal });
    const q = selector => root.querySelector(selector);
    const labels = JSON.parse(q('[data-review-labels]').textContent);
    const label = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll('[' + k + ']', String(v)), labels[Number(values.count) === 1 && labels[key + '_one'] ? key + '_one' : key] || '');
    let timer, deadline, lastRequestedCount = -1, requests = 0, finished = false;
    let reviewPage = 1, records = [], renderedCount = 0, writeBound = false, seededCount = 0;
    const rating = q('#review-rating');
    const sort = q('#review-sort');
    const photos = q('#review-with-photos');
    const grid = q('#reviews-grid');
    const result = q('#review-results');
    const breakpoint = matchMedia('(max-width:767px)');

    function isPageHiddenReview(author, date, message = '', photoCount = 0) {
      if (root.dataset.reviewProduct === '9269357773120') return author === 'Amber C.' && date === '2026-05-15';
      return root.dataset.reviewProduct === '4521922166893' && author === 'Gerhardt A.' && date === '2025-11-29' && photoCount === 0 && message.replace(/\s+/g, '') === 'thesehasbeenaconstantwithmefor11yearsthepatinaonthissaddlecolorwallethasbeenamazing.';
    }

    function element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }

    function render(scroll = false) {
      const pageSize = 4;
      const filtered = records.filter(r => (rating.value === 'all' || r.stars === Number(rating.value)) && (!photos.checked || r.photos.length));
      filtered.sort((a, b) => {
        const recent = b.date.localeCompare(a.date) || a.index - b.index;
        if (sort.value === 'photos') return Number(Boolean(b.photos.length)) - Number(Boolean(a.photos.length)) || recent;
        if (sort.value === 'oldest') return -recent;
        if (sort.value === 'highest') return b.stars - a.stars || recent;
        if (sort.value === 'lowest') return a.stars - b.stars || recent;
        return recent;
      });
      const pages = Math.max(1, Math.ceil(filtered.length / pageSize));
      reviewPage = Math.max(1, Math.min(reviewPage, pages));
      const start = (reviewPage - 1) * pageSize;
      grid.replaceChildren(...filtered.slice(start, start + pageSize).map(r => r.card));
      result.textContent = label('results', { start: filtered.length ? start + 1 : 0, end: Math.min(start + pageSize, filtered.length), count: filtered.length });
      q('[data-reviews-empty]').hidden = filtered.length > 0;
      q('#reviews-prev').disabled = reviewPage <= 1;
      q('#reviews-next').disabled = reviewPage >= pages;
      q('[data-review-page]').textContent = label('page', { page: reviewPage, pages });
      q('#review-reset').hidden = rating.value === 'all' && !photos.checked;
      root.querySelectorAll('[data-rating-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ratingFilter === rating.value)));
      if (scroll) { result.scrollIntoView({ block: 'start', behavior: 'instant' }); result.focus({ preventScroll: true }); }
    }
    function makeCard(record) {
      const card = element('article', 'customer-review');
      card.dataset.stars = record.stars;
      card.dataset.photos = record.photos.length;
      const top = element('div', 'review-card-top');
      const stars = element('span', 'review-stars');
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', label('out_of_five', { rating: record.stars }));
      const filled = element('span', '', '★'.repeat(record.stars));
      filled.setAttribute('aria-hidden', 'true');
      const empty = element('span', 'unfilled-stars', '★'.repeat(5 - record.stars));
      empty.setAttribute('aria-hidden', 'true');
      stars.append(filled, empty);
      const time = element('time');
      time.dateTime = record.date;
      time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(new Date(record.date + 'T12:00:00Z'));
      top.append(stars, time);
      const quote = element('blockquote');
      quote.append(element('p', '', record.message));
      const author = element('div', 'review-author');
      author.append(element('h3', '', record.author));
      if (record.verified) author.append(element('span', 'review-verified', '✓ ' + record.verified));
      card.append(top, quote, author);
      if (record.photos.length) {
        const gallery = element('div', 'review-photos');
        record.photos.forEach((original, index) => {
          const button = element('button', 'review-photo');
          button.type = 'button';
          const alt = label('photo', { number: index + 1, name: record.author });
          button.setAttribute('aria-label', alt);
          const img = element('img');
          img.src = original.currentSrc || original.src;
          img.alt = alt;
          img.width = 96; img.height = 112; img.loading = 'lazy'; img.decoding = 'async';
          const plus = element('span', '', '+'); plus.setAttribute('aria-hidden', 'true');
          button.append(img, plus);
          on(button, 'click', () => original.click());
          gallery.append(button);
        });
        card.append(gallery);
      }
      return card;
    }

    function arrange() {
      const distribution = q('.rating-distribution');
      const tools = q('#review-tools');
      if (breakpoint.matches) q('#mobile-review-filters').append(distribution, tools);
      else { q('#review-distribution-home').after(distribution); q('#review-tools-home').after(tools); }
    }

    function fallback() {
      if (records.length) { loading.hidden = true; return; }
      finished = true;
      clearTimeout(deadline); clearTimeout(timer); observer.disconnect();
      root.classList.remove('mh-reviews-loading');
      loading.hidden = true; source.hidden = false; source.removeAttribute('aria-hidden');
      layout.hidden = true;
      root.classList.add('mh-reviews-fallback');
      const pager = element('nav', 'review-pagination');
      pager.setAttribute('aria-label', 'Reviews');
      const previous = element('button', '', label('previous') || 'Previous');
      const pageLabel = element('span');
      const next = element('button', '', label('next') || 'Next');
      previous.type = next.type = 'button';
      pager.append(previous, pageLabel, next); source.after(pager);
      let nativePage = 1;
      function limitNativeReviews(){
        const cards = [...source.querySelectorAll('.vtl-pr-ri__wrapper')].filter(card => {
          const author = card.querySelector('.vtl-pr-ri__user-name')?.textContent.trim();
          const date = card.querySelector('.vtl-pr-ri__date')?.textContent.match(/\d{4}-\d{2}-\d{2}/)?.[0];
          const message = card.querySelector('.vtl-pr-ri__message')?.textContent.trim() || '';
          const photoCount = card.querySelectorAll('.vtl-pr-ri__images img').length;
          if (!isPageHiddenReview(author, date, message, photoCount)) return true;
          card.style.setProperty('display', 'none', 'important');
          return false;
        });
        const pages = Math.max(1, Math.ceil(cards.length / 4));
        nativePage = Math.min(nativePage, pages);
        cards.forEach((card, index) => card.style.setProperty('display', index >= (nativePage - 1) * 4 && index < nativePage * 4 ? '' : 'none', 'important'));
        previous.disabled = nativePage <= 1; next.disabled = nativePage >= pages;
        pageLabel.textContent = label('page', {page:nativePage, pages});
        pager.hidden = cards.length <= 4;
      }
      on(previous, 'click', () => {nativePage--; limitNativeReviews(); root.scrollIntoView({block:'start'});});
      on(next, 'click', () => {nativePage++; limitNativeReviews(); root.scrollIntoView({block:'start'});});
      observer.disconnect();
      const fallbackObserver = new MutationObserver(limitNativeReviews);
      fallbackObserver.observe(source, {childList:true, subtree:true});
      controller.signal.addEventListener('abort', () => {fallbackObserver.disconnect();pager.remove();});
      limitNativeReviews();
    }

    function complete(nodes, final = false, seeded = false) {
      try {
        records = nodes.map((node, index) => {
          if (seeded) {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(node.date) || !node.message || !node.author || !Number.isInteger(node.stars) || node.stars < 1 || node.stars > 5 || !Array.isArray(node.photos)) throw new Error('Invalid saved review');
            const record = { ...node, index, photos: node.photos.map(url => { const image = document.createElement('img'); image.src = url; return image; }) };
            record.card = makeCard(record);
            return record;
          }
          const stars = Math.round(parseFloat(node.querySelector('.vtl-pr-ri__stars .Vtl-pr-stars-snippet--front')?.style.width) / 20);
          const date = node.querySelector('.vtl-pr-ri__date')?.textContent.match(/\d{4}-\d{2}-\d{2}/)?.[0];
          const message = node.querySelector('.vtl-pr-ri__message')?.textContent.trim();
          const author = node.querySelector('.vtl-pr-ri__user-name')?.textContent.trim();
          if (!date || !message || !author || !Number.isInteger(stars) || stars < 1 || stars > 5) throw new Error('Unsupported review format');
          const record = { index, date, message, author, stars, verified: node.querySelector('.vtl-pr-ri__uv-text')?.textContent.trim(), photos: Array.from(node.querySelectorAll('.vtl-pr-ri__images img')) };
          record.card = makeCard(record);
          return record;
        });
        records = records.filter(record => !isPageHiddenReview(record.author, record.date, record.message, record.photos.length));
        if (root.dataset.reviewProduct === '8868966334784') records = records.filter(record => !(record.author === 'Kit W.' && record.date === '2026-09-30'));
        const ledgerDuplicateCount = root.dataset.reviewProduct === '4521922166893' ? nodes.length - records.length : 0;
        const originalCount = Number(root.dataset.reviewCount) || nodes.length;
        const count = ledgerDuplicateCount ? originalCount - ledgerDuplicateCount : (root.dataset.reviewProduct === '8868966334784' ? records.length : (Number(root.dataset.reviewCount) || records.length));
        let average = Number(root.dataset.reviewAverage) || records.reduce((sum, r) => sum + r.stars, 0) / records.length;
        if (ledgerDuplicateCount && nodes.length >= originalCount) average = records.reduce((sum, r) => sum + r.stars, 0) / records.length;
        if (ledgerDuplicateCount) {
          document.querySelectorAll('.product-review-link .product-rating-score').forEach(node => { node.textContent = node.textContent.replace(/[\d.,]+/, average.toFixed(2)); });
          document.querySelectorAll('.product-review-link .product-rating-count').forEach(node => { node.textContent = node.textContent.replace(/\d[\d,]*/, String(count)); });
        }
        q('[data-review-score]').textContent = average.toFixed(2);
        q('[data-review-total]').textContent = label('based_on', { count });
        q('.aggregate-stars').setAttribute('aria-label', label('out_of_five', { rating: average.toFixed(2) }));
        q('.aggregate-filled').style.width = (average / 5 * 100) + '%';
        q('[data-photo-filter-label]').textContent = label('with_photos', { count: records.filter(r => r.photos.length).length });
        root.querySelectorAll('[data-rating-filter]').forEach(button => {
          const value = Number(button.dataset.ratingFilter);
          const amount = records.filter(r => r.stars === value).length;
          button.setAttribute('aria-label', label('show_rating', { count: amount, rating: value }));
          button.querySelector('[data-rating-count]').textContent = amount;
          button.querySelector('.rating-track span').style.width = (amount / count * 100) + '%';
          rating.querySelector('option[value="' + value + '"]').textContent = label('stars_count', { rating: value, count: amount });
        });
        const write = source.querySelector('.vtl-pr-reviews__write button');
        if (write && !writeBound) {
          writeBound = true;
          q('[data-write-review]').hidden = false;
          on(q('[data-write-review]'), 'click', () => {
            source.querySelector('[data-vtl-pr-write-review]')?.click();
            setTimeout(() => source.querySelector('.vtl-grid__form-holder')?.scrollIntoView({ block: 'start', behavior: 'smooth' }), 100);
          });
        }
        if (final && !records.some(r => r.photos.length)) photos.checked = false;
        arrange(); render();
        renderedCount = seeded ? 0 : nodes.length;
        if (seeded) seededCount = nodes.length;
        if (final) { finished = true; clearTimeout(deadline); observer.disconnect(); }
        root.classList.remove('mh-reviews-loading');
        root.classList.add('mh-reviews-ready');
        root.dataset.reviewState = seeded ? 'saved' : 'live';
        loading.hidden = true; source.hidden = false; source.removeAttribute('aria-hidden'); layout.hidden = false;
      } catch { fallback(); }
    }
    function inspect() {
      if (finished || !root.isConnected) return;
      const nodes = Array.from(source.querySelectorAll('.vtl-pr-ri__wrapper'));
      const total = parseInt(source.querySelector('.vtl-pr-totals__reviews')?.textContent.replace(/,/g, ''), 10);
      if (!nodes.length || !total) return;
      if (nodes.length >= total) { complete(nodes, true); return; }
      if (nodes.length !== renderedCount && nodes.length >= seededCount) complete(nodes);
      if (finished) return;
      const more = source.querySelector('.vtl-pr-main-widget__show-more-button');
      if (!more || more.disabled || nodes.length <= lastRequestedCount) return;
      if (requests >= 20 || total > 300) { if (nodes.length >= seededCount) complete(nodes, true); return; }
      lastRequestedCount = nodes.length; requests++;
      more.click();
    }

    const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(inspect, 100); });
    function reset() { rating.value = 'all'; photos.checked = false; reviewPage = 1; render(); }
    [rating, sort, photos].forEach(input => on(input, 'change', () => { reviewPage = 1; render(); }));
    root.querySelectorAll('[data-rating-filter]').forEach(button => on(button, 'click', () => { rating.value = button.dataset.ratingFilter; reviewPage = 1; render(); }));
    on(q('#review-reset'), 'click', reset);
    on(q('[data-empty-reset]'), 'click', reset);
    on(q('#reviews-prev'), 'click', () => { reviewPage--; render(true); });
    on(q('#reviews-next'), 'click', () => { reviewPage++; render(true); });
    on(breakpoint, 'change', () => { arrange(); reviewPage = 1; if (records.length) render(); });
    root.classList.add('mh-reviews-loading'); source.setAttribute('aria-hidden', 'true'); loading.hidden = false;
    observer.observe(source, { childList: true, subtree: true });
    try {
      const seed = JSON.parse(q('[data-review-snapshot]')?.textContent || 'null');
      if (seed?.version === 1 && String(seed.productId) === root.dataset.reviewProduct && Array.isArray(seed.records) && seed.records.length > 0 && seed.records.length === Number(root.dataset.reviewCount)) complete(seed.records, false, true);
    } catch { /* Keep loading the live reviews if saved data is unavailable. */ }
    deadline = setTimeout(() => {
      const nodes = Array.from(source.querySelectorAll('.vtl-pr-ri__wrapper'));
      if (nodes.length && nodes.length >= seededCount) complete(nodes, true); else if (!records.length) fallback();
    }, 25000);
    inspect();
    instances.set(root, () => { controller.abort(); observer.disconnect(); clearTimeout(timer); clearTimeout(deadline); });
  }

  function init() {
    for (const [root, cleanup] of instances) if (!root.isConnected) { cleanup(); instances.delete(root); }
    document.querySelectorAll('[data-mh-reviews]').forEach(root => { if (!instances.has(root)) mount(root); });
  }
  window.mhLttReviewsInit = init;
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
  init();
})();


